<template>
  <div
    class="d-flex flex-column-fluid align-items-start container-xxl"
    data-select2-id="select2-data-kt_content_container"
  >
    <div
      class="content flex-row-fluid"
      data-select2-id="select2-data-kt_content"
      v-if="isLoaded"
    >
      <!--begin::Navbar-->
      <div class="card mb-5 mb-xl-10">
        <div class="card-body pt-9 pb-0">
          <!--begin::Details-->
          <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
            <!--begin: Pic-->
            <div class="me-7 mb-4">
              <div
                class="
                  symbol symbol-100px symbol-lg-160px symbol-fixed
                  position-relative
                "
              >
                <img
                  :src="`https://www.terapikoltugu.app/storage/photos/${user.photo}`"
                  alt="image"
                />
                <div
                  class="
                    position-absolute
                    translate-middle
                    bottom-0
                    start-100
                    mb-6
                    bg-success
                    rounded-circle
                    border border-4 border-white
                    h-20px
                    w-20px
                  "
                ></div>
              </div>
            </div>
            <!--end::Pic-->
            <!--begin::Info-->
            <div class="flex-grow-1">
              <!--begin::Title-->
              <div
                class="
                  d-flex
                  justify-content-between
                  align-items-start
                  flex-wrap
                  mb-2
                "
              >
                <!--begin::User-->
                <div class="d-flex flex-column">
                  <!--begin::Name-->
                  <div class="d-flex align-items-center mb-2">
                    <span
                      class="
                        text-gray-900 text-hover-primary
                        fs-2
                        fw-bolder
                        me-1
                      "
                      >{{ user.name }} {{ user.surname }}</span
                    >
                  </div>
                  <!--end::Name-->
                  <!--begin::Info-->
                  <div class="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                    <a
                      href="#"
                      class="
                        d-flex
                        align-items-center
                        text-gray-400 text-hover-primary
                        mb-2
                      "
                    >
                      <span class="svg-icon svg-icon-4 me-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            opacity="0.3"
                            d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                            fill="black"
                          ></path>
                          <path
                            d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                            fill="black"
                          ></path>
                        </svg>
                      </span>
                      {{ user.email }}</a
                    >
                  </div>
                  <!--end::Info-->
                </div>
                <!--end::User-->
              </div>
            </div>
            <!--end::Info-->
          </div>
          <!--end::Details-->
          <!--begin::Navs-->
          <ul
            class="
              nav nav-stretch nav-line-tabs nav-line-tabs-2x
              border-transparent
              fs-5
              fw-bolder
            "
          >
            <li
              class="nav-item mt-2"
              v-for="(item, index) in menu"
              :key="`profile-menu-${index}`"
            >
              <router-link
                class="nav-link text-active-primary ms-0 me-10 py-5"
                :key="index"
                :to="{ name: item.name }"
                v-slot="{ href, navigate, isActive }"
              >
                <a :href="href" :class="{ active: isActive }" @click="navigate">
                  {{ item.meta.title }}
                </a>
              </router-link>
            </li>
          </ul>
          <!--begin::Navs-->
        </div>
      </div>
      <!--end::Navbar-->
      <!--begin::Basic info-->
      <div class="card mb-5 mb-xl-10" data-select2-id="select2-data-81-y0jh">
        <!--begin::Content-->
        <div
          id="kt_account_settings_profile_details"
          class="collapse show"
          data-select2-id="select2-data-kt_account_settings_profile_details"
        >
          <transition name="fade" mode="out-in">
            <router-view />
          </transition>
        </div>
        <!--end::Content-->
      </div>
    </div>
    <!--end::Post-->
  </div>
</template>

<script>
import * as API from "@/services/";
import { findMenu } from "@/helpers";
export default {
  data() {
    return {
      isLoaded: false,
      token: this.$store.getters.getAccessToken,
      user: null,
    };
  },
  computed: {
    menu: function () {
      let _menu = findMenu(this.$router.options.routes, "profile");

      return _menu;
    },
  },
  async created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo: async function () {
      let vm = this;

      if (!vm.token) return;

      let response = await API.getUserInfo(vm.token);

      if (response.status == "fail")
        return vm.$store.dispatch("logout").then(() => location.reload());

      vm.user = response.data;

      return (vm.isLoaded = true);
    },
    makeDate: function (date) {
      let d = new Date(date);

      let months = [
        "Ocak",
        "Şubat",
        "Mart",
        "Nisan",
        "Mayıs",
        "Haziran",
        "Temmuz",
        "Ağustos",
        "Eylül",
        "Ekim",
        "Kasım",
        "Aralık",
      ];

      let day = d.getDate();
      let month = d.getMonth();
      let year = d.getFullYear();

      let _date = `${day < 10 ? "0" + day : day} ${months[month]} ${year}`;

      return _date;
    },
  },
};
</script>